module.exports = __webpack_public_path__ + "static/media/teemat.88a9a5b7.svg";